import { useState, useEffect } from "react";
import axios from "axios";
import { Clock, ArrowUpRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Anonymised placement outcomes — no client names. Renders nothing until an
// admin publishes at least one real entry.
const CaseStudies = ({ variant = "light", heading = "Teams We've Helped Build", intro }) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios.get(`${API}/case-studies`).then(res => setItems(res.data || [])).catch((e) => console.warn("Failed to load case studies", e));
  }, []);

  if (items.length === 0) return null;

  const dark = variant === "dark";

  return (
    <section
      className={dark ? "py-24 bg-[#1A1A1A]" : "py-24 bg-[#FAF9F6]"}
      data-testid="case-studies"
    >
      <div className="max-w-7xl mx-auto px-8 md:px-16">
        <div className="max-w-2xl mb-14">
          <span className={dark ? "text-[#B8860B] text-xs tracking-[0.25em] uppercase" : "text-overline"}>
            Who We Build
          </span>
          <h2 className={`heading-section mt-4 ${dark ? "text-white" : ""}`}>{heading}</h2>
          <p className={`mt-4 ${dark ? "text-gray-400" : "text-body"}`}>
            {intro || "The hires that move companies forward — from first key hire to leadership."}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((c) => (
            <div
              key={c.id}
              className={`p-8 border transition-colors ${dark ? "border-gray-800 bg-[#222] hover:border-[#B8860B]/40" : "border-gray-200 bg-white hover:border-[#B8860B]/40"}`}
              data-testid={`case-study-${c.id}`}
            >
              <div className="flex items-start justify-between gap-3 mb-4">
                <h3 className={`font-display text-xl ${dark ? "text-white" : "text-gray-900"}`}>{c.role}</h3>
                <ArrowUpRight size={18} className="text-[#B8860B] flex-shrink-0 mt-1" />
              </div>

              {(c.stage || c.sector) && (
                <div className="flex flex-wrap gap-2 mb-5">
                  {c.stage && (
                    <span className="text-[10px] uppercase tracking-wider text-[#B8860B] border border-[#B8860B]/30 px-2 py-0.5">
                      {c.stage}
                    </span>
                  )}
                  {c.sector && (
                    <span className={`text-[10px] uppercase tracking-wider px-2 py-0.5 border ${dark ? "text-gray-400 border-gray-700" : "text-gray-500 border-gray-200"}`}>
                      {c.sector}
                    </span>
                  )}
                </div>
              )}

              {c.outcome && (
                <p className={`text-sm leading-relaxed mb-5 ${dark ? "text-gray-300" : "text-gray-600"}`}>
                  {c.outcome}
                </p>
              )}

              {c.days_to_hire != null && (
                <div className={`flex items-center gap-2 pt-4 border-t ${dark ? "border-gray-800" : "border-gray-100"}`}>
                  <Clock size={14} className="text-[#B8860B]" />
                  <span className={`text-sm font-medium ${dark ? "text-white" : "text-gray-900"}`}>
                    {c.days_to_hire} days to hire
                  </span>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CaseStudies;
